import { render, staticRenderFns } from "./FormNetStreamRecordStreamax.vue?vue&type=template&id=58fcb9c3&scoped=true&"
import script from "./FormNetStreamRecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormNetStreamRecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormNetStreamRecordStreamax.vue?vue&type=style&index=0&id=58fcb9c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fcb9c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('58fcb9c3', component.options)
    } else {
      api.reload('58fcb9c3', component.options)
    }
    module.hot.accept("./FormNetStreamRecordStreamax.vue?vue&type=template&id=58fcb9c3&scoped=true&", function () {
      api.rerender('58fcb9c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Record/FormNetStreamRecordStreamax.vue"
export default component.exports